const complaintsReducer = (
  state = {
    loading: false,
    data: null,
    totalCount: null,
    selectedComplaint: null,
    filter: {
      category: [],
      dateRange: {
        from: null,
        to: null
      },
      issueRaised: "",
      PCTNo: []
    },
    searchKey: "",
    sortBy: "desc"
  },
  action
) => {
  switch (action.type) {
    case "SET_COMPLAINTS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_COMPLAINTS":
      return {
        ...state,
        data: action.payload.data
      };

    case "PUT_SELECTED_COMPLAINT":
      return {
        ...state,
        selectedComplaint: action.payload.data
      };

    case "SET_COMPLAINTS_COUNT":
      return {
        ...state,
        totalCount: action.payload.data
      };

    case "CLEAR_COMPLAINTS":
      return {
        ...state,
        data: null
      };

    case "PUT_COMPLAINTS_FILTER":
      return {
        ...state,
        filter: action.payload.data
      };

    case "PUT_COMPLAINTS_SEARCH_KEY":
      return {
        ...state,
        searchKey: action.payload.data
      };

    case "PUT_COMPLAINTS_SORT":
      return {
        ...state,
        sortBy: action.payload.data
      };

    case "RESET":
      return {
        loading: false,
        data: null,
        totalCount: null,
        filter: {
          category: [],
          dateRange: {
            from: null,
            to: null
          },
          issueRaised: "",
          PCTNo: []
        },
        searchKey: "",
        sortBy: "desc"
      };

    default:
      return state;
  }
};
export default complaintsReducer;
